import React from "react";
import { Box, Typography } from "@mui/material";

function NotificationState({ icon, title, description, action = null }) {
  return (
    <Box className="notification-state">
      <Box>{icon}</Box>
      <Typography sx={{ fontWeight: 700, color: "#30465c" }}>{title}</Typography>
      {/* <Typography sx={{ mt: 0.5 }}>{description}</Typography> */}
      {action}
    </Box>
  );
}

export default React.memo(NotificationState);
